// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1K1in","requiredAsterisk":"Info_requiredAsterisk__Vs_gF"};